import type { IWidget } from "app/components/widget/widget-types/Widget";
import type { IDataFetcher, IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import { fetchWithFullResponseInterceptorHandlers } from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { getAverageData, getDemographicData } from "app/pages/app-intelligence/app-analysis/pages/Demographics/helpers";

class AppDemographicsDataFetcher<T> implements IDataFetcher<T> {
    protected widget: IWidget<T>;
    constructor(widget) {
        this.widget = widget;
    }
    fetch(params: any = this.widget.apiParams) {
        const stateName = this.widget._metricConfig.state;
        return getDemographicData(
            {
                ...params,
                key: params.keys,
            },
            stateName,
        )
            .then(...fetchWithFullResponseInterceptorHandlers)
            .then((response) => {
                const { genderData: gender, ageData: age } = getAverageData(response.AppsDemographics);
                const responseData = { gender, age };
                return { Data: responseData[params.demographicDataKey] } as any;
            });
    }

    destroy() {
        return undefined;
    }
}

const AppDemographicsDataFetcherFactory: IDataFetcherFactory<any> = {
    create: function (widget) {
        return new AppDemographicsDataFetcher<any>(widget);
    },
};

export default AppDemographicsDataFetcherFactory;
